import { render, staticRenderFns } from "./SignOutButton.vue?vue&type=template&id=55d3a037&scoped=true&"
import script from "./SignOutButton.vue?vue&type=script&lang=js&"
export * from "./SignOutButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d3a037",
  null
  
)

export default component.exports